import { render } from "./TranslationView.vue?vue&type=template&id=4497fc7d&scoped=true"
import script from "./TranslationView.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./TranslationView.vue?vue&type=script&charset=utf-8&lang=js"

import "./TranslationView.vue?vue&type=style&index=0&id=4497fc7d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4497fc7d"]])

export default __exports__